/** 火种(方案 C3.5):混沌纪核心物,亮核+双光晕+持续上升余烬。 */
import { Stage, LW, GROUND_Y } from '../engine/Stage';
import { GlowBody } from './GlowBody';
import { eventPool } from '../engine/ParticlePool';
import { TEX } from '../engine/Tex';
import { P } from '../engine/Palette';
import { rand } from '../engine/util';

export class FireSeed {
  glow: GlowBody;
  x = LW * 0.5;
  y = GROUND_Y - 20;
  private t = 0;
  private emit = 0;
  private sizeMul = 1;
  private urgency = 0;   // 里程碑冲刺(≥85%):火种躁动脉动,预告跃迁

  /** 2026-07-18 决定:火种不再渲染(Captain 拍板"去掉")。白昼下它只是一粒来历
   *  不明的黄点,神圣感立不住;信仰的视觉锚点由神像胸前火珠与灯窗承担。
   *  类与 API(setSize/setUrgency)保留,纪元跃迁等调用方零改动——只是无形。 */
  constructor(_stage: Stage) {
    this.glow = new GlowBody(P.emberHi, 14, P.ember);
    this.glow.root.position.set(this.x, this.y);
    // 不上台:glow.root 不 addChild,余烬不再发射
  }

  update(dt: number) {
    this.t += dt;
    void this.urgency; void this.emit; void rand; void eventPool; void TEX;
  }
  /** 纪元跃迁前奏:火种膨胀 */
  setSize(m: number) { this.sizeMul = m; this.glow.setScale(m); }
  /** 里程碑冲刺预热(0=平静,1=躁动) */
  setUrgency(u: number) { this.urgency = u; }
}
